import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SnackbarPayload {
  message: string;
  severity?: "error" | "warning" | "info" | "success";
}

const snackbarSlice = createSlice({
  name: "snackbar",
  initialState: {
    message: "",
    open: false,
    severity: "info",
  },
  reducers: {
    showSnackbar(state, action: PayloadAction<SnackbarPayload>) {
      state.message = action.payload.message;
      state.severity = action.payload.severity || "info";
      state.open = true;
    },
    hideSnackbar(state) {
      state.open = false;
    },
  },
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
